// import * as constant from '../mutation-constant'
import { setUserBasket, clearUserBasket } from '../../helpers/localStorage'
import calculateBreakdownPrice from '../../helpers/calculateBreakdownPrice'

export default {
  addBasketSuccess: (state, payload) => {
    state.items.push(payload)
    setUserBasket(state.items)
  },
  addBasketError: (state, payload) => {
    state.error = payload
  },
  removeBasketSuccess: (state, payload) => {
    state.items = payload
    setUserBasket(payload)
  },
  removeBasketByIndex(state, index) {
    state.items.splice(index, 1)
  },
  removeBasketById(state, id) {
    const findIndex = state.items.findIndex((item) => item.id === id)
    if (findIndex > -1) {
      state.items.splice(findIndex, 1)
    }
  },
  addToHistoryBasket: (state, payload) => {
    state.historyBasket.push(payload)
  },
  removeAllBasketSuccess: (state) => {
    state.items = []
    state.discount = {}
    state.historyBasket = []
    state.isBindedData = false
    state.campaignMassBook = null
    clearUserBasket()
  },
  updateKeyContact: (state, payload) => {
    const index = state.items.findIndex((item) => item.id === payload.basketId)
    const tempData = JSON.parse(JSON.stringify(state.items[index].keyContact))
    Object.assign(tempData, payload)
    if (index > -1) {
      state.items[index].keyContact = tempData
      // Object.assign(state.items[index].keyContact, payload)
    }
  },
  updateBookingItems: (state, payload) => {
    const findItemIndex = state.items.findIndex(
      (item) => item.id === payload.basketId
    )
    const tempData = JSON.parse(JSON.stringify(state.items))
    tempData[findItemIndex].bookingItems = payload.bookingItems
    // Only set contactConfirmed for Brand book for (venue and venue group not set this).
    if (payload.hasOwnProperty('contactConfirmed')) {
      tempData[findItemIndex].contactConfirmed = payload.contactConfirmed
    }
    state.items = tempData
  },
  updateBasketItem: (state, payload) => {
    const findItemIndex = state.items.findIndex(
      (item) => item.id === payload.itemId
    )
    state.items[findItemIndex].addressConfirmed = payload.addressConfirmed
  },
  updateForwardEmail: (state, payload) => {
    const findItemIndex = state.items.findIndex(
      (item) => item.id === payload.basketId
    )
    const tempData = Object.assign([], state.items)
    tempData[findItemIndex].forwardUserId = payload.forwardUserId
    delete tempData[findItemIndex].budgetCode
    state.items = tempData
  },
  updateBudgetCode: (state, payload) => {
    const findItemIndex = state.items.findIndex(
      (item) => item.id === payload.basketId
    )
    const tempData = Object.assign([], state.items)
    tempData[findItemIndex].budgetCode = {}
    tempData[findItemIndex].budgetCode._id = payload.budgetCodeId
    tempData[findItemIndex].budgetCode.name = payload.budgetCodeName
    delete tempData[findItemIndex].forwardUserId
    state.items = tempData
  },
  removeBudgetCode: (state, payload) => {
    const findItemIndex = state.items.findIndex(
      (item) => item.id === payload.basketId
    )
    const tempData = Object.assign([], state.items)
    delete tempData[findItemIndex].budgetCode
    state.items = tempData
  },
  setStoreAddressTo: (state, payload) => {
    state.storeAddressTo = payload
  },
  setDeliveryAddresses: (state, payload) => {
    state.deliveryAddresses = payload
  },
  updateDeliveryAddresses: (state, payload) => {
    state.deliveryAddresses.unshift(payload)
  },
  toggleBasketOverlay: (state, payload) => {
    state.isShowBasketOverlay = payload
  },
  updateBasketPriceBreakdown: (state, payload) => {
    state.items = state.items.filter(
      (item, index) => index === state.items.length - 1
    )
    state.items.forEach((item) => {
      const {
        quantity,
        bookingData: {
          campaign: { allowedMultiplePurchase },
        },
      } = item
      item.bookingData.campaign.priceBreakdown = payload
      item.campaign.priceBreakdown = payload

      // Calculate additional price
      const getBreakdownPrice = calculateBreakdownPrice(
        payload,
        quantity,
        allowedMultiplePurchase
      )
      item.bookingData.campaign.priceBreakdown.additionalPrice = {
        quantity,
        price: getBreakdownPrice.totalPriceIncVat,
      }
    })
  },
  setDiscountCode: (state, payload) => {
    state.discount = payload
    state.items.forEach((item) => {
      payload.campaigns.forEach((discountCode) => {
        if (item.id === discountCode.id) {
          item.bookingData.discount = discountCode
        }
      })
    })
  },
  clearDiscountCode: (state) => {
    state.discount = {}
    state.items.forEach((item) => {
      item.bookingData.discount = {}
    })
  },
  setIsPaidBasket: (state, payload) => {
    state.isPaidBasket = payload
  },
  updateBasketDisplay: (state, payload) => {
    state.basketData = { ...payload }
  },
  setAddressSelected: (state, payload) => {
    state.delierySelectedAddress = { ...payload }
  },
  setBinding: (state, value) => {
    state.isBindedData = value
  },
  setMassBooking: (state, payload) => {
    state.isMassBooking = payload
  },
  setCampaignMassbook: (state, payload) => {
    state.campaignMassBook = payload
  },
}
